import { Automations as AutomationsOld } from "../components/Marketing/Automations";

export function Automations() {
  return (
    <div className="flex size-full max-h-full flex-col gap-y-4 p-4 lg:p-8">
      <AutomationsOld />
    </div>
  );
}
